let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Wh15")).then(() => parcelRequire('chd24'));